import {
  f,
  fmtDateTime,
  fmtName,
  type WOClipboardContext,
} from "./formatSessionClipboard";

export type StandbyClipboardContext = Pick<
  WOClipboardContext,
  "ticketNumber" | "turbineSerialNumber" | "woAssignees"
>;

function workOrderLine(ticketNumber: number | null | undefined) {
  return `Work Order: ${ticketNumber != null ? `#${ticketNumber}` : "—"}`;
}

// Assignees can only be picked from the technician list, so the WO's assignees are
// its technician team.
function wtgAndTeamLines({ turbineSerialNumber, woAssignees }: StandbyClipboardContext) {
  return [
    `WTG: ${f(turbineSerialNumber)}`,
    `Team: ${woAssignees.length > 0 ? woAssignees.map(fmtName).join(", ") : "—"}`,
  ];
}

export function formatStandbyStartClipboard(
  context: StandbyClipboardContext,
  {
    reason,
    startedAt,
  }: { reason: string | null | undefined; startedAt: string | null | undefined }
): string {
  return [
    "Standby Start",
    workOrderLine(context.ticketNumber),
    `Reason: ${f(reason)}`,
    `Date and time: ${fmtDateTime(startedAt)}`,
    ...wtgAndTeamLines(context),
  ].join("\n");
}

// A standby reported with a "standby until" time is announced with both ends at once.
export function formatStandbyContinuousClipboard(
  context: StandbyClipboardContext,
  {
    reason,
    startedAt,
    plannedEnd,
  }: {
    reason: string | null | undefined;
    startedAt: string | null | undefined;
    plannedEnd: string | null | undefined;
  }
): string {
  return [
    "Continuous Standby",
    workOrderLine(context.ticketNumber),
    `Reason: ${f(reason)}`,
    `Standby start date and time: ${fmtDateTime(startedAt)}`,
    `Standby end date and time: ${fmtDateTime(plannedEnd)}`,
    ...wtgAndTeamLines(context),
  ].join("\n");
}

export function formatStandbyReportedClipboard(
  context: StandbyClipboardContext,
  standby: {
    reason: string | null | undefined;
    startedAt: string | null | undefined;
    plannedEnd: string | null | undefined;
  }
): string {
  return standby.plannedEnd
    ? formatStandbyContinuousClipboard(context, standby)
    : formatStandbyStartClipboard(context, standby);
}

export function formatStandbyEndClipboard(
  context: StandbyClipboardContext,
  { endedAt }: { endedAt: string | null | undefined }
): string {
  return [
    "Standby End",
    workOrderLine(context.ticketNumber),
    `Date and time: ${fmtDateTime(endedAt)}`,
    ...wtgAndTeamLines(context),
  ].join("\n");
}
